import { type ReactNode, useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { Card as LCCard } from "../../Configurators/Linear/components/Card";
import { Popper, type PopperPlacementType } from "@mui/material";

type PopperTooltipProps = {
  tooltipContent: ReactNode;
  placement?: PopperPlacementType;
  zIndex?: number;
  innerClassName?: string;
  isNavigation?: boolean;
  hideTooltip?: boolean;
  onTooltipClosed?: () => void;
  onTooltipOpened?: () => void;
  disableFlip?: boolean;
  contentClassName?: string;
  cardVariant?: "rounded" | "square";
} & JSX.IntrinsicElements["div"];

export const PopperTooltip = (props: PopperTooltipProps) => {
  const {
    tooltipContent,
    placement = "bottom-start",
    children,
    className,
    zIndex,
    innerClassName,
    isNavigation,
    hideTooltip = false,
    onTooltipClosed,
    onTooltipOpened,
    disableFlip,
    contentClassName,
    cardVariant = "square",
    ...divProps
  } = props;

  const [hoveredElement, setHoveredElement] = useState<string[]>([]);
  const enableHoverRefManipulation = useRef<boolean>(true);

  const containerRef = useRef<HTMLDivElement | null>(null);

  const addHover = (el: string) => () => {
    if (!enableHoverRefManipulation.current) {
      return;
    }
    if (!hideTooltip) {
      setHoveredElement((prev) => prev.concat(el));
    }
    // enableHoverRefManipulation.current = false;
    // window.setTimeout(() => (enableHoverRefManipulation.current = true), 25);
  };
  const removeHover = (el: string) => () => {
    if (!enableHoverRefManipulation.current) {
      return;
    }
    // enableHoverRefManipulation.current = false;
    // window.setTimeout(() => (enableHoverRefManipulation.current = true), 25);
    window.setTimeout(() => setHoveredElement((prev) => prev.filter((item) => item !== el)), 100);
  };

  useEffect(() => {
    if (hideTooltip) {
      setHoveredElement([]);
    }
  }, [hideTooltip]);

  const isOpen = hoveredElement.length > 0;

  useEffect(() => {
    if (onTooltipClosed && !isOpen) {
      onTooltipClosed();
    }
    if (onTooltipOpened && isOpen) {
      onTooltipOpened();
    }
  }, [isOpen]);

  const popperStyle = zIndex ? { zIndex } : undefined;

  return (
    <>
      <div
        ref={containerRef}
        className={classNames("scha__tooltip__container", className)}
        onMouseEnter={addHover("container")}
        onMouseLeave={removeHover("container")}
        {...divProps}
      >
        {children}
      </div>
      {tooltipContent !== null && (
        <Popper
          open={isOpen}
          anchorEl={containerRef.current}
          placement={placement}
          className={classNames(
            "scha__popper-tooltip",
            isNavigation && "scha__popper-tooltip__navigation",
            contentClassName,
          )}
          style={popperStyle}
          modifiers={
            disableFlip
              ? [
                  {
                    name: "flip",
                    options: {
                      fallbackPlacements: [],
                    },
                  },
                ]
              : undefined
          }
        >
          <LCCard
            variant={cardVariant}
            disableHover={true}
            innerClassName={classNames("scha__popper-tooltip__inner", innerClassName)}
            onMouseEnter={addHover("tooltip")}
            onMouseLeave={removeHover("tooltip")}
          >
            {tooltipContent}
          </LCCard>
        </Popper>
      )}
    </>
  );
};
